export const logout = () => {
  sessionStorage.clear();
  window.location.replace("/admin");
};

export const isLogin = () => {
  if (sessionStorage.getItem("token") && sessionStorage.getItem("tokenVerified") && sessionStorage.getItem("token") !== "undefined" && sessionStorage.getItem("tokenVerified") !== "undefined") {
    if (sessionStorage.getItem("token") === sessionStorage.getItem("tokenVerified")) {
      return true;
    }
    return false;
  }
  return false;
};
